'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'tiny-warning';
import { getSwanIconUrl, SWAN_ICON_KEY_MAP } from '../../../core/utilities/manifest-icons.utils.js';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { swanStyleObjectFit } from '../../../core/utilities/swan-style.utils.js';
import { tokens } from '../../../core/tokens/index.js';
import { MANIFEST_ICONS } from '../../../core/manifest/icons.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let l = Object.entries(MANIFEST_ICONS).reduce((e, [t, r])=>{
    if (r.deprecated) {
        let o = r.deprecated.message || 'See alternatives on the Swan docsite.';
        e[t] = o;
    }
    return e;
}, {}), u = {
    sustainability: tokens.SwanSemColorBrandFern
};
const Icon = renderWithRef('Icon', null, (i, a)=>{
    useDeprecatedProps('Icon', i, [
        {
            propName: 'iconType',
            deprecatedValues: l
        },
        {
            propName: 'size',
            deprecatedValues: {
                '10p': 'Use "16p" instead.',
                '28p': 'Use "standard" instead.',
                '32p': 'Use "standard" instead.',
                '40p': 'Use "standard" instead.',
                '48p': 'Use "standard" instead.',
                '60p': 'Use "standard" instead.'
            }
        },
        {
            propName: 'skin',
            deprecatedValues: {
                white: 'Use "standard" instead in dark mode'
            }
        }
    ]);
    let { children: c, src: b, size: f, skin: m = 'standard', iconType: y, objectFit: _, alt: j, style: O } = i, w = _object_without_properties(i, [
        "children",
        "src",
        "size",
        "skin",
        "iconType",
        "objectFit",
        "alt",
        "style"
    ]), { swanPathType: g, swanBaseUrl: A } = useSwanContext(), h = !!b, v = Object.keys(SWAN_ICON_KEY_MAP), P = !!(y && v.includes(y));
    t(!(!b && !P), 'Icon: Either iconType is missing or invalid or if you are trying to use it as custom icon the `src` has not been passed');
    let k = '';
    y && P && (k = getSwanIconUrl(y, g, A));
    let S = k ? `url(${k})` : void 0, E = _object_spread_props(_object_spread({}, O), {
        maskImage: S,
        WebkitMaskImage: S
    }), x = new Set([
        'swan-icon',
        'swan-icon-mask'
    ]), I = swanStyleObjectFit(_);
    return I && x.add(I), f && x.add(`swan-icon-size-${f}`), y && y in u ? E = _object_spread_props(_object_spread({}, E), {
        backgroundColor: u[y]
    }) : m && x.add(`swan-icon-skin-${m}`), h ? x.add('swan-icon-custom') : P && x.add(`swan-icon-type-${y}`), jsx(RenderComp, {
        root: "img",
        forwardedRef: a,
        classNames: x,
        props: _object_spread_props(_object_spread({}, w), {
            style: E,
            src: b || (S ? 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' : void 0),
            alt: j || '',
            draggable: false
        }),
        children: c
    });
});

export { Icon };
